import * as React from "react";
import { forwardRef } from "react";
const TruckBedLinerIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M16.105 3.192a.75.75 0 0 1 .563.4L17.96 6.11l-.012.005.038.123.023.112.386 2.589.941-.396.072-.026a.75.75 0 0 1 .579 1.376l-.069.033-1.131.476 1.595 4.608c.107.184.168.397.168.625v4.6a1.25 1.25 0 0 1-1.25 1.25H4.6a1.25 1.25 0 0 1-1.25-1.25v-4.6c0-.06.006-.119.014-.177l-.015-.005.034-.103c.019-.081.046-.158.079-.231l1.623-4.783-.976-.41-.069-.033a.75.75 0 0 1 .579-1.376l.072.026.82.345.432-2.896-.01-.005.015-.029.006-.033.012.001 1.275-2.348.055-.087a.75.75 0 0 1 .604-.306H16l.105.007zM4.85 19.985h1v-1.5h-1v1.5zm0-3H6.6a.75.75 0 0 1 .75.75v2.25h9.2v-2.25a.75.75 0 0 1 .75-.75h1.75v-1.1H4.85v1.1zm13.2 3h1v-1.5h-1v1.5zm-12.755-5.6h1.902l.76-3.601H6.68a1.19 1.19 0 0 1-.159-.011l-1.226 3.611zm3.436 0h2.619v-3.601H9.49l-.76 3.601zm4.119 0h2.526l-.64-3.601H12.85v3.601zm4.37-3.601h-.96l.641 3.601h1.678l-1.247-3.607-.111.007zm-10.25-1.5h9.96l-.372-2.5H7.342l-.372 2.5zm1.052-4h7.829l-.309-.6H8.347l-.325.6z"
}));
const ForwardRef = forwardRef(TruckBedLinerIcon);
export default ForwardRef;